import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import i18n from "@/utils/i18n";
import { useMediaQuery } from "react-responsive";
import {
  useUserInfoStore,
  useLoadingStore,
  usePopupStore,
  useAuthStore,
  useGlobalStore,
} from "@/stores";
import {
  ScrollAnchor,
  ChooseLanguage,
  Popup,
  WorkList,
  Loading,
  SharePanel,
  Login,
  Message,
  Footer,
} from "@/components";
import Api from "@/service";
import { setLangImages } from "@/lang/imgMap";
import { getPageImages } from "@/config/imagePaths";
import { getSupportLanguagesMap, communityType } from "@/config";
import { useLanguageStore } from "@/stores";
import { getEnvConfig } from "@/utils/getEnv";
import { getLevel } from "@/utils";

import {
  discord,
  facebook,
  youtube,
  progress0,
  progress2,
  progress4,
  progress6,
  progress0V,
  progress1V,
  progress2V,
  progress3V,
  progress4V,
} from "@/assets/images/common";

import "./index.scss";

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { currentLanguage: lang, setLanguage } = useLanguageStore();

  console.log({ lang });
  const { isLoading, loadingText } = useLoadingStore();
  const { creationList, userInfo, fetchShareCode, refreshUserInfo, award } =
    useUserInfoStore();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { initialize, fetchCreationList } = useGlobalStore();
  const { isLoggedIn } = useAuthStore();
  const { popupInfo, closePopup, openPopup } = usePopupStore();
  const [prizeDescVisible, setPrizeDescVisible] = useState<boolean>(false);
  // 获取页面图片资源
  const batchImages = getPageImages(lang);

  useEffect(() => {
    initialize();
  }, []);

  console.log({ userInfo });

  useEffect(() => {
    // 当语言改变时更新所有图片CSS变量
    setLangImages(lang);
  }, [lang]);

  // 点击页面任意地方关闭奖品描述
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (prizeDescVisible) {
        setPrizeDescVisible(false);
      }
    };

    if (prizeDescVisible) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [prizeDescVisible]);

  // 锚点状态变化回调
  const handleActiveChange = (activeId: string) => {
    console.log("当前激活的锚点:", activeId);
  };

  // 语言切换
  const handleLangChange = (newLang: string) => {
    setLanguage(newLang as any);
    setLangImages(newLang);
    i18n.changeLanguage(newLang);
  };

  // 获取分享码
  const onGetCode = async () => {
    if (!isLoggedIn) {
      return Message.error({ content: t("login") });
    }
    await fetchShareCode();
    openPopup("share");

    console.log("onGetCode");
  };
  const onQueryReward = () => {
    if (!isLoggedIn) {
      return Message.error({ content: t("login") });
    }
    openPopup("award");
    console.log("onQueryReward");
  };

  const onOpenLink = (type: "facebook" | "youtube" | "discord") => {
    let currentLang = getSupportLanguagesMap().find(
      (config) => config.value === lang
    );
    let url = "";

    if (lang === "en") {
      const envUrls = currentLang?.urls as any;
      url = envUrls?.[getEnvConfig().env]?.[type] || "";
    } else {
      const urls = currentLang?.urls as any;
      url = urls?.[type] || "";
    }

    // 跳转新页面
    if (url) {
      window.open(url, "_blank");
      onJoinCommunity(type);
    }
  };

  // 加入社群
  const onJoinCommunity = async (type: "facebook" | "youtube" | "discord") => {
    const res = await Api.joinCommunity(
      communityType[type as keyof typeof communityType]
    );

    if (res.code === 0) {
      refreshUserInfo();
    }
  };

  const onSuccess = () => {
    refreshUserInfo();
  };

  const onVote = async (id: number) => {
    // 先校验是否登录
    if (!isLoggedIn) {
      return Message.error({ content: t("login") });
    }
    const res = await Api.voteCreation(id);
    if (res.code === 0) {
      Message.success({ content: t("voteSuccess") });
      refreshUserInfo();
      fetchCreationList();
    }
  };

  const getProgressImg = (
    count: number,
    layout: "horizontal" | "vertical" = "horizontal"
  ) => {
    if (layout === "horizontal") {
      if (count === 0) {
        return progress0;
      } else if (count === 1) {
        return progress2;
      } else if (count === 2) {
        return progress4;
      } else if (count === 3) {
        return progress6;
      } else {
        return progress0;
      }
    } else {
      if (count === 0) {
        return progress0V;
      } else if (count === 1) {
        return progress1V;
      } else if (count === 2) {
        return progress2V;
      } else if (count === 3) {
        return progress3V;
      } else if (count === 4) {
        return progress4V;
      } else {
        return progress0V;
      }
    }
  };

  return (
    <div className='home'>
      {/* 语言切换按钮 */}
      <div className='home__top'>
        {getSupportLanguagesMap().length > 1 && (
          <ChooseLanguage
            onSelect={handleLangChange}
            selected={lang}
            items={getSupportLanguagesMap().map((config) => ({
              name: `${config.name}`,
              value: config.value,
            }))}
          />
        )}
        <Login />
      </div>

      {isMobile ? (
        <div className='home__mobile'>
          <section className='home__section p1'>
            <div className='section-content'>
              <div className='cover'>
                <img
                  src={
                    isMobile
                      ? batchImages["mobile_p1-cover_png"]
                      : batchImages["pc_p1_cover_png"]
                  }
                  alt=''
                />
              </div>
            </div>
          </section>
          <section className='home__section p2'>
            <div className='section-content'>
              <img src={batchImages["mobile_p2-rules_png"]} alt='' />
              <div className='code__container'>
                <SharePanel
                  variant='mobile'
                  onGetCode={onGetCode}
                  batchImages={batchImages}
                />
              </div>
            </div>
          </section>
          <section className='home__section p3'>
            <div className='section-content'>
              <img src={batchImages["mobile_p3-cover_png"]} alt='' />
              <div className='ticket'>
                <div className='progress progress-1'>
                  <img
                    src={getProgressImg(userInfo.join_community_count)}
                    alt=''
                  />
                  <div className='links'>
                    <div
                      className='link facebook'
                      onClick={() => onOpenLink("facebook")}>
                      <img src={facebook} alt='' />
                    </div>
                    <div
                      className='link youtube'
                      onClick={() => onOpenLink("youtube")}>
                      <img src={youtube} alt='' />
                    </div>
                    <div
                      className='link discord'
                      onClick={() => onOpenLink("discord")}>
                      <img src={discord} alt='' />
                    </div>
                  </div>
                </div>
                <div className='progress progress-2'>
                  <img
                    src={getProgressImg(getLevel(userInfo.active_count))}
                    alt=''
                  />
                </div>
                <div className='progress progress-3'>
                  <img
                    src={getProgressImg(getLevel(userInfo.invite_user))}
                    alt=''
                  />
                </div>
                <div className='progress progress-4'>
                  <img
                    src={getProgressImg(getLevel(userInfo.use_share_code))}
                    alt=''
                  />
                </div>
              </div>
            </div>
          </section>
          <section className='home__section p4'>
            <div className='section-content'>
              <img src={batchImages["mobile_p4-cover_png"]} alt='' />

              <div className='prize-desc'>
                <div
                  className='prize-desc-btn'
                  onClick={(e) => {
                    e.stopPropagation();
                    setPrizeDescVisible(!prizeDescVisible);
                  }}></div>
                <div
                  className={classnames("prize-desc-picture", {
                    show: prizeDescVisible,
                  })}>
                  <img src={batchImages["pc_p2_prize-desc_jpg"]} alt='' />
                </div>
              </div>

              <div className='progress'>
                <img src={getProgressImg(award.length, "vertical")} alt='' />
              </div>
              <div className='submit' onClick={onQueryReward}>
                <img src={batchImages["pc_p2_queryReward_png"]} alt='' />
              </div>
            </div>
          </section>
          <section className='home__section p5'>
            <div className='section-content'>
              <div className='top'>
                <img src={batchImages["mobile_p3-title_png"]} alt='' />
              </div>
              <div
                className='voteTicket'
                style={
                  lang === "pt" || lang === "hi" ? { fontSize: "13px" } : {}
                }>
                <div className='currentlyPossessed'>{t("total")}</div>
                <div className='total'>
                  {userInfo.vote_ticket - userInfo.use_ticket || 0}
                </div>
                <div className='used'>{t("used")}</div>
                <div className='count'>{userInfo.use_ticket || 0}</div>
              </div>
              <WorkList
                items={creationList}
                buttonImage={batchImages["pc_p3_btn_png"]}
                onVote={(item) => onVote(item.id)}
              />
            </div>
          </section>
        </div>
      ) : (
        <>
          <section id='section-1' className='home__section p1'>
            <div className='section-content'>
              <div className='cover'>
                <img
                  src={
                    isMobile
                      ? batchImages["mobile_p1-cover_png"]
                      : batchImages["pc_p1_cover_png"]
                  }
                  alt=''
                />
              </div>
            </div>
          </section>
          <section id='section-2' className='home__section p2'>
            <div className='section-content'>
              <div className='title'>
                <img src={batchImages["pc_p2_title_png"]} alt='' />
              </div>
              <div className='desc'>
                <img src={batchImages["pc_p2_desc_png"]} alt='' />
              </div>
              <div className='content'>
                <div className='part part1'>
                  <div className='rules'>
                    <img src={batchImages["pc_p2_rules_png"]} alt='' />
                  </div>
                  <div className='vote'>
                    <img src={batchImages["pc_p2_vote_png"]} alt='' />
                    <div
                      className={classnames("ticket", {
                        th: lang === "th",
                        hi: lang === "hi",
                      })}>
                      <div className='progress progress-1'>
                        <img
                          src={getProgressImg(userInfo.join_community_count)}
                          alt=''
                        />
                      </div>
                      <div className='progress progress-2'>
                        <img
                          src={getProgressImg(getLevel(userInfo.active_count))}
                          alt=''
                        />
                      </div>
                      <div className='progress progress-3'>
                        <img
                          src={getProgressImg(getLevel(userInfo.invite_user))}
                          alt=''
                        />
                      </div>
                      <div className='progress progress-4'>
                        <img
                          src={getProgressImg(
                            getLevel(userInfo.use_share_code)
                          )}
                          alt=''
                        />
                      </div>
                    </div>
                    <div className='links'>
                      <div
                        className='link'
                        onClick={() => onOpenLink("facebook")}>
                        <img src={facebook} alt='' />
                      </div>
                      <div
                        className='link'
                        onClick={() => onOpenLink("youtube")}>
                        <img src={youtube} alt='' />
                      </div>
                      <div
                        className='link'
                        onClick={() => onOpenLink("discord")}>
                        <img src={discord} alt='' />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='part part2'>
                  <SharePanel onGetCode={onGetCode} batchImages={batchImages} />
                  <div className='prize'>
                    <img src={batchImages["pc_p2_prize_png"]} alt='' />
                    <div className='prize-desc'>
                      <div
                        className='prize-desc-btn'
                        onClick={(e) => {
                          e.stopPropagation();
                          setPrizeDescVisible(!prizeDescVisible);
                        }}></div>
                      <div
                        className={classnames("prize-desc-picture", {
                          show: prizeDescVisible,
                        })}>
                        <img src={batchImages["pc_p2_prize-desc_jpg"]} alt='' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='submit' onClick={onQueryReward}>
                <img src={batchImages["pc_p2_queryReward_png"]} alt='' />
              </div>
            </div>
          </section>
          <section id='section-3' className='home__section p3'>
            <div className='section-content'>
              <div className='title'>
                <img src={batchImages["pc_p3_title_png"]} alt='' />
              </div>
              <div className='voteTicket'>
                <div className='currentlyPossessed'>{t("total")}</div>
                <div className='total'>
                  {userInfo.vote_ticket - userInfo.use_ticket || 0}
                </div>
                <div className='used'>{t("used")}</div>
                <div className='count'>{userInfo.use_ticket || 0}</div>
              </div>
              <WorkList
                items={creationList}
                buttonImage={batchImages["pc_p3_btn_png"]}
                onVote={(item) => onVote(item.id)}
              />
            </div>
          </section>
        </>
      )}

      <Footer env={getEnvConfig().env} />

      {/* 锚点组件 */}
      {!isMobile && <ScrollAnchor lang={lang} />}

      <Popup {...popupInfo} onClose={closePopup} onSuccess={onSuccess} />

      {/* 全局API Loading */}
      <Loading
        spinning={isLoading}
        tip={loadingText}
        mask={true}
        showPulseRing={true}
        animationType='both'
        size='default'
      />
    </div>
  );
};

export default Home;
